import { useState, useEffect } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import AvgEscReportTable from "./AvgEscReportTable";
import useLogout from "../../hooks/useLogout";
import { useNavigate } from "react-router-dom";

const AvgEscReport = () => {
    const logout = useLogout();
    const navigate = useNavigate();
    const [ticketDetails, setTicketDetails] = useState(false);
    const axiosPrivate = useAxiosPrivate();
    const [filterError, setFilterError] = useState(false)
    const [project, setProject] = useState("last_ten_escalations");
    const [quarter, setQuarter] = useState("quarter");
    const [year, setYear] = useState("year");
    const currentYear = new Date().getFullYear(); 
    const startYear = 2022;
    const years = Array.from({ length: currentYear - startYear + 1 }, (_, i) => startYear + i);
    

    useEffect(() => {
        let isMounted = true;
        const controller = new AbortController();

        const getRecentEscalations = async () => {
            try {
                const response = await axiosPrivate.get('/report', {
                    signal: controller.signal
                });
                isMounted && setTicketDetails(response.data);
            } catch (err) {
                if(err.message !== 'canceled'){
                    await logout();
                    navigate('/login')
                }
            }
        }

        getRecentEscalations();

        return () => {
            isMounted = false;
            controller.abort();
        }
        // eslint-disable-next-line
    }, [])



    const handleFilter = async () => {
        try {
            setFilterError(false)
            if (project === 'last_ten_escalations') {
                setYear("year")
                return getEscalationsTickets();
            } else if (year === 'year'){
             return setFilterError("Please select the valid Year")
            }
            getEscalationsTickets();
        } catch (err) {
            if(err.message !== 'canceled'){
                await logout();
            }
        }
    }

    // const getEscalationsTickets = async () => {
    //     try {
    //             setTicketDetails(false)
    //             let url = project === 'last_ten_escalations' ? '/report' : `/report?project=${project}&&year=${year}&&quarter=${quarter}`
    //             const response = await axiosPrivate.get(url);
    //             if(response.data.msg) return setTicketDetails({});
    //             setTicketDetails(response.data);
    //     } catch (err) {
    //         if(err.message !== 'canceled'){
    //             await logout();
    //         }
    //     }
    // } 
    const getEscalationsTickets = async () => {
        try {
            setTicketDetails(false);
            let url = project === 'last_ten_escalations' ? '/report' : `/report?project=${project}&&year=${year}`;
            if (quarter !== 'quarter') {
                url += `&&quarter=${quarter}`;
            }
            const response = await axiosPrivate.get(url);
            if (response.data.msg) return setTicketDetails({});
            setTicketDetails(response.data);
        } catch (err) {
            if (err.message !== 'canceled') {
                await logout();
            }
        }
    };

  return (
    <AvgEscReportTable project={project} handleFilter={handleFilter} ticketDetails={ticketDetails} setProject={setProject} filterError={filterError} years={years} setYear={setYear} setQuarter={setQuarter}/>
  )
}

export default AvgEscReport
